import * as o from "react";
import { c as r } from "../createReactComponent-58f9bea8.mjs";
import { D as t, r as m } from "../dropdown-3820c146.mjs";
import "../property-9daa16cd.mjs";
import "../state-7560d4dc.mjs";
import "../class-map-2994e95e.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../button-7600b6ca.mjs";
import "../icon-c572aa57.mjs";
import "../icon-button-a9d2a2d1.mjs";
const l = r({ tagName: "ex-dropdown", elementClass: t, react: o, events: {}, displayName: "ExDropdown", registerWebComponent: m });
export {
  l as ExDropdown,
  m as register
};
